import React from "react";
import { useNavigate } from "react-router-dom";

const AgentDesignReviewPortals: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="content">
      <div className="po-header mb-4 shadow-border-datatables">
        <div className="po-top d-flex justify-content-between align-items-center flex-wrap gap-2">
          <div className="po-title-wrap me-2">
            <h4 className="mb-1 po-title">Projects</h4>
            <p className="mb-0 text-muted">Open your design review conversation portal.</p>
          </div>
        </div>
      </div>

      <div className="card shadow-border-datatables p-4">
        <div className="d-flex flex-column align-items-start gap-3">
          <h5 className="mb-0">Agent Design Review Portal</h5>
          <p className="mb-0 text-muted">Click the button below to view your full design conversation UI.</p>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => navigate("/agent/design-review-portal")}
          >
            View Conversation
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgentDesignReviewPortals;
